module.exports = __webpack_public_path__ + "static/media/Harpoon_Missile_01.59b09ead.jpg";